import LiveStreamComponent from "../../../components/academy/livestream";

const AcademyLiveStream = () => {
    return (
        <div className="w-full">
            <LiveStreamComponent />
        </div>
    )
}

export default AcademyLiveStream;